class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    this.performRecommendations();

    // Recommendation attribution params are stored on each link's data-pr-tracking
    // attribute (not the href) to keep product links clean for SEO. Read them on click
    // for analytics. Delegated because the items are injected after the fetch.
    this.addEventListener('click', e => {
      const link = e.target.closest('a[data-pr-tracking]');
      if (!link || !this.contains(link)) return;

      const params = Object.fromEntries(
        new URLSearchParams(link.dataset.prTracking)
      );

      this.dispatchEvent(
        new CustomEvent('lj:recommendation-click', {
          bubbles: true,
          detail: { url: link.getAttribute('href'), params }
        })
      );

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: 'recommendation_click',
          recommendation: { url: link.getAttribute('href'), ...params }
        });
      }
    });
  }

  performRecommendations() {
    const recommendations = this.querySelector(
      '[data-recommendations]'
    );
    if (!recommendations) return;
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const recommendationsHMTL = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]').innerHTML;
        if (!recommendationsHMTL) return;
        this.classList.remove('hidden');
        recommendations.innerHTML = recommendationsHMTL;
        this.initSlider();
      });
  }

  initSlider() {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 8
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
